export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ssZZ';
export const API_PERIOD_FORMAT = 'YYYY-MM';
export const USER_DATE_FORMAT = 'DD/MM/YYYY';
export const USER_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const USER_PERIOD_FORMAT = 'MMM YY';
